module.exports = __webpack_public_path__ + "img/logo.727e96e9.png";